import styled, { css } from 'styled-components';
import { H1Text } from '@prisjakt/ui/text/variants';
import { layout, media } from '@prisjakt/ui-base';

export const Hero = styled.div<{
  $active: boolean;
  $backgroundImage: string;
  $fullWidth: boolean;
}>`
  width: 100%;
  max-width: 980px;
  height: 224px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('${p => p.$backgroundImage}');
  background-size: cover;
  background-position: center;
  margin: auto;
  padding: ${layout.measurements.spacing150};
  margin-top: ${layout.measurements.spacing050};

  ${p => media.smallOnly`
    height: auto;
    padding: ${layout.measurements.spacing150} ${layout.measurements.spacing150} ${layout.measurements.spacing300} ${layout.measurements.spacing150};
    margin-top: 0;
  `}

  ${p => (!p.$active ? 'height: 0; overflow: hidden;' : '')}
  ${p =>
    p.$fullWidth &&
    css`
      margin-top: 0;
      max-width: unset;
    `}
`;

export const Content = styled.div`
  flex-grow: 1;
  max-width: 500px;
  color: ${p => p.theme.colors.base0};
`;

export const SearchWrapper = styled.div`
  top: 0;
  z-index: 108;
`;

export const HeroTitle = styled(H1Text)`
  margin-bottom: ${layout.measurements.spacing100};
  white-space: pre;
  text-align: center;
  ${p => media.smallOnly`
    white-space: initial;
  `}
`;
